(ns practitest.frontend.user-link-result.views
  (:require
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.components.icons :as icons]
   [re-frame.core :as re-frame]))

(re-frame/reg-sub
  ::link-result-data
  (fn [db _]
    (get-in db [:options :link-result-data])))

(defn- close-window! []
  (.close js/window)
  (js/setTimeout #(when (not (.-closed js/window))
                    (.open js/window "" "_self" "")
                    (.close js/window))
                 100))

(defn- link-result-success []
  [:<>
   [:h3.link-result-title.link-result-title--success
    (get-translation "user-link-result.success.title" "Account Linked Successfully!")]
   [:p.link-result-description
    (get-translation "user-link-result.success.body1" "Your account is now configured in PractiTest.")
    [:br]
    (get-translation "user-link-result.success.body2" "You may close this window.")]
   [:button.link-result-btn-close {:on-click close-window!}
    (get-translation "user-link-result.close-window" "Close Window")]])

(defn- link-result-failure [authorize_url]
  [:<>
   [:h3.link-result-title.link-result-title--failure
    (get-translation "user-link-result.failure.title" "Account Linking Failed")]
   [:p.link-result-description
    (get-translation "user-link-result.failure.body1" "We couldn't link your account to PractiTest.")
    [:br]
    (get-translation "user-link-result.failure.body2" "Please try again or contact support.")]
   [:div.link-result-actions
    [:button.link-result-btn-outline {:on-click close-window!}
     (get-translation "user-link-result.close-window" "Close Window")]
    (when authorize_url
      [:a.link-result-btn-primary {:href authorize_url :target "_blank"}
       (get-translation "user-link-result.try-again" "Try Again")])]
   [:p.link-result-support
    (get-translation "user-link-result.need-help" "Need Help?")
    " "
    [:a {:href "https://www.practitest.com/support" :target "_blank"}
     (get-translation "user-link-result.contact-support" "Contact Support")]]])

(defn user-link-result-page [_route]
  (let [data (re-frame/subscribe [::link-result-data])]
    (fn [_route]
      (let [{:keys [status authorize_url mascot_url]} @data
            success? (= status "success")]
        [:div.user-link-result-page
         [:div.user-link-result-card
          [icons/mux-fox-linked-or-unlinked {:linked? success? :mascot-url mascot_url}]
          (if success?
            [link-result-success]
            [link-result-failure authorize_url])]]))))
